import { TICKET_COST_CLIENT, TICKET_COST_ENT, TICKET_COST_HES, TICKET_COST_IMAC } from '../shared/pricing.js';

const IMAC_FULL_DAY_MINUTES = 7.5 * 60;

export function getTicketRevenue(
  ticketType: string | null | undefined,
  serviceDurationMinutes?: number | null,
): number {
  switch (ticketType) {
    case 'Client':
      return TICKET_COST_CLIENT;
    case 'Enterprise':
      return TICKET_COST_ENT;
    case 'HES':
      return TICKET_COST_HES;
    case 'IMAC':
      if (serviceDurationMinutes != null) {
        const proportion = serviceDurationMinutes / IMAC_FULL_DAY_MINUTES;
        return TICKET_COST_IMAC * proportion;
      }
      return TICKET_COST_IMAC;
    default:
      return 0;
  }
}
